import type { DepGraphActivity } from "../../../models";
import type { DepCandidate } from "./DepChipTypeahead/DepChipTypeahead";
import { activityLabel, zoneFull } from "./graphRows";

export function buildCandidates(
  activities: DepGraphActivity[],
  linkCandidates: DepGraphActivity[] = [],
): DepCandidate[] {
  // In-section linkable targets: the editable section members (in_scope) PLUS
  // completed section members (link_candidates — kept out of `activities` so
  // they don't render as rows, but are still valid tie targets). Out-of-section
  // work is searched separately via the typeahead's external-discovery path.
  const sorted = [...activities.filter((a) => a.in_scope), ...linkCandidates]
    .sort((a, b) => {
    const aStart = a.start ?? "";
    const bStart = b.start ?? "";
    return aStart.localeCompare(bStart) || a.name.localeCompare(b.name);
  });
  // Dedupe by activity id (each activity is its own candidate). Keying on
  // work_code would collapse distinct uncoded rows (e.g. milestones) that all
  // share work_code="".
  const seen = new Set<string>();
  const out: DepCandidate[] = [];
  for (const a of sorted) {
    if (seen.has(a.id)) continue;
    seen.add(a.id);
    out.push({
      instanceId: a.id,
      workCode: a.work_code,
      displayName: activityLabel(a),
      taskName: a.name,
      zoneLabel: zoneFull(a),
      startIso: a.start,
      finishIso: a.finish,
      color: a.color,
      complete: a.complete,
    });
  }
  return out;
}
